export var FlexBoxWrap;
(function (FlexBoxWrap) {
    /**
     * All will stay on one line. <br />
     * <b>Note:</b> Corresponds to `nowrap`.
     */
    FlexBoxWrap["NoWrap"] = "NoWrap";
    /**
     * Items will wrap onto multiple lines. (top to bottom)<br />
     * <b>Note:</b> Corresponds to `wrap`.
     */
    FlexBoxWrap["Wrap"] = "Wrap";
    /**
     * Items will wrap onto multiple lines. (bottom to top)<br />
     * <b>Note:</b> Corresponds to `wrap-reverse`.
     */
    FlexBoxWrap["WrapReverse"] = "WrapReverse";
})(FlexBoxWrap || (FlexBoxWrap = {}));
